import { Component } from '@angular/core';
import { Page } from './../../models/pages/pages.model';
import { CommunicationService } from './../../shared/services/communication.service';

import { ApiService } from './../../shared/services/api.service';
import { ListBase } from './../../shared/components/base/list/list.base.component';

@Component({
  selector: 'swb-pages-list',
  templateUrl: './../../shared/components/base/list/list.base.component.html'
})
export class PageListComponent extends ListBase<Page> {

  public url = 'pages';

  constructor(
    _apiService: ApiService,
    _communicationService: CommunicationService
  ) {
    super(
      _apiService,
      _communicationService
    );
  }

}
